module.exports = __webpack_public_path__ + "static/Sonyax5b-f46d45ff27603c14518bd55f19d85784.png";